export default __webpack_public_path__ + "static/media/snowboard_light.d9662bdb.png";